import { DerivedMemberType, MemberInfo, MemberType } from "@/types/member";

export const getMemberName = (memberInfo: MemberInfo): string => {
  return (
    memberInfo.nickname?.trim() ||
    [memberInfo.firstName, memberInfo.lastName].filter(Boolean).join(" ").trim()
  );
};

export const getMemberNickFirst = (memberInfo: MemberInfo): string => {
  return memberInfo.nickname?.trim() || memberInfo.firstName?.trim();
};

export const checkChildStatus = (memberInfo: MemberInfo): boolean => {
  return (
    memberInfo.memberType === MemberType.HUMAN &&
    memberInfo.derivedMemberType === DerivedMemberType.C
  );
};

export const sanitizedEmail = (email: string): string => {
  return email.trim().toLowerCase();
};
